export default __webpack_public_path__ + "static/media/dimmia-def-icona-bianco_512.2116dd4e.png";